import { Component, Input } from '@angular/core';

@Component({
  selector: 'rdo-logo',
  imports: [],
  templateUrl: './logo.component.html',
  styleUrl: './logo.component.scss',
})
export class LogoComponent {
  @Input() url: string | null;
  @Input() title?: string = 'Client Logo';
}
